// Utility function to set daily donation status in local storage
export function setDailyDonationStatus(urls = ['30-steps-to-jannah', 'laylatul-qadr-last-10-nights', 'jummah-giving', 'recurring-giving']) {
  const path = window.location.pathname;
  // Check if the path does not include "checkout"
  if (!path.includes('checkout')) {
    const isDailyDonation = urls.some(url => path.includes(url));
    localStorage.setItem('IS_DAILY_DONATION', JSON.stringify(isDailyDonation));
  }
}
